<template>
  <notLoginLayout class="forget-account">
    <b-form>
      <b-form-group
        label="信箱"
        label-for="check-email"
        class="required-icon-star"
      >
        <b-form-input
          id="check-email"
          v-model="form.email"
          :state="verifyEmail"
          :title="'輸入格式有誤'"
          type="text"
          required
          placeholder=""
        ></b-form-input>
      </b-form-group>
    </b-form>
    <div class="forget text-right">
      <b-button
        @click.prevent="verifyForm"
        class="mr-3"
        type="button"
        variant="primary"
        >送出</b-button
      >
      <b-button
        @click="$router.push({ name: 'login' })"
        type="submit"
        variant="dark"
        >取消</b-button
      >
    </div>
  </notLoginLayout>
</template>

<script>
import notLoginLayout from "@/layout/NotLoginLayout.vue";
import mixinsVerify from "@/utility/mixinsVerify.js";
export default {
  components: {
    notLoginLayout
  },
  data() {
    return {
      form: {
        email: ""
      }
    };
  },
  mixins: [mixinsVerify],
  methods: {
    verifyForm() {
      this.verifyEmail =
        this.hasValue(this.form.email) === null
          ? this.emailRegexp(this.form.email)
          : false;
      if (this.verifyEmail === false) return;
      else this.onSubmit();
    },
    onSubmit() {
      const sendMailMessage = "系統已寄信，請至信箱確認";
      const emailNotFindMessage = "此信箱未申請帳號";
      switch (this.$store.getters.currentForgetFlow) {
        case "password":
          this.$store
            .dispatch("sentForgetPasswordEmail", this.form)
            .then(() => {
              alert(sendMailMessage);
              this.$router.push({ name: "login" });
            })
            .catch(e => {
              if (e.status === 400) {
                alert(emailNotFindMessage);
              }
            });
          break;
        default:
        case "account":
          this.$store
            .dispatch("sentForgetAccountEmail", this.form)
            .then(() => {
              alert(sendMailMessage);
              this.$router.push({ name: "login" });
            })
            .catch(e => {
              if (e.status === 400) {
                this.verifyEmail = false;
                alert(emailNotFindMessage);
              }
            });
          break;
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
